// JWM branding assets + version marker (jwm-branding-v1).
// Referenced by LoginPage + the global toolbar so a live-bundle marker grep can
// confirm the branding shipped. Bump the version suffix when the logo/favicon
// set is re-cut so cached HTML/asset references can be reasoned about.

export const BP_BRANDING_VERSION = 'jwm-branding-v4'

// JWM eagle/lion mark (transparent PNG, no wordmark). The "JWM" wordmark is
// rendered as real text next to it in the toolbar/login, so this one asset works
// on both dark and light surfaces (the mark keeps dark outlines).
// Toolbar logo inside the CRM = the red lion. (The eagle/lion crest lives on the
// login page only, as /jwm-logo.png.)
export const BP_LOGO_DARK = '/jwm-lion.png?v=jwm4'
export const BP_LOGO_LIGHT = '/jwm-lion.png?v=jwm4'

export const BP_LOGO_ALT = 'JWM'
